import React from 'react';
import ContentLoader from 'react-content-loader';
import PropTypes from 'prop-types';
import * as Styled from './SpecCard.Skeleton.styles';

var SpecCardSkeleton = function SpecCardSkeleton(_ref) {
  var height = _ref.height,
      width = _ref.width,
      speed = _ref.speed,
      primaryColor = _ref.primaryColor,
      secondaryColor = _ref.secondaryColor;
  return /*#__PURE__*/React.createElement(Styled.Wrapper, {
    loading: true
  }, /*#__PURE__*/React.createElement(ContentLoader, {
    viewBox: "0 0 ".concat(width, " ").concat(height),
    speed: speed,
    backgroundColor: primaryColor,
    foregroundColor: secondaryColor,
    uniqueKey: "sc-desktop-content-loader",
    className: "xs-hidden sm-block"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    rx: "10",
    ry: "10",
    width: "410",
    height: "410"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "425",
    rx: "10",
    ry: "10",
    width: "60",
    height: "60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "435",
    y: "2",
    rx: "10",
    ry: "10",
    width: "420",
    height: "33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "435",
    y: "57",
    rx: "10",
    ry: "10",
    width: "315",
    height: "33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "985",
    y: "2",
    rx: "10",
    ry: "10",
    width: "200",
    height: "33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "985",
    y: "57",
    rx: "10",
    ry: "10",
    width: "150",
    height: "33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "435",
    y: "125",
    rx: "10",
    ry: "10",
    width: "860",
    height: "260"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "985",
    y: "425",
    rx: "10",
    ry: "10",
    width: "310",
    height: "60"
  })), /*#__PURE__*/React.createElement(ContentLoader, {
    viewBox: "0 0 ".concat(width, " ").concat(height + 800),
    speed: speed,
    primaryColor: primaryColor,
    secondaryColor: secondaryColor,
    uniqueKey: "sc-mobile-content-loader",
    className: "sm-hidden"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    rx: "10",
    ry: "10",
    width: "400",
    height: "400"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "435",
    y: "0",
    rx: "10",
    ry: "10",
    width: "700",
    height: "90"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "435",
    y: "105",
    rx: "10",
    ry: "10",
    width: "560",
    height: "90"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "435",
    y: "220",
    rx: "10",
    ry: "10",
    width: "200",
    height: "80"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "420",
    rx: "10",
    ry: "10",
    width: "1300",
    height: "700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "1145",
    rx: "10",
    ry: "10",
    width: "1300",
    height: "150"
  })));
};

SpecCardSkeleton.propTypes = {
  /**
   * Optional prop for the height
   */
  height: PropTypes.number,

  /**
   * Optional prop for the width
   */
  width: PropTypes.number,

  /**
   * Optional prop for the speed of the gradient
   */
  speed: PropTypes.number,

  /**
   * Optional prop for the primary colour for the gradient
   */
  primaryColor: PropTypes.string,

  /**
   * Optional prop for the secondary colour for the gradient
   */
  secondaryColor: PropTypes.string
};
SpecCardSkeleton.defaultProps = {
  height: 485,
  width: 1300,
  speed: 1,
  primaryColor: '#f3f3f3',
  secondaryColor: '#ecebeb'
};
export default SpecCardSkeleton;